import $ from 'jquery';
import Cookies from 'js-cookie';

const $banner = $('#top-banner');
const $close = $('#close-btn');

if ($banner.length && $close.length) {
  const bannerClosed = Cookies.get('banner_closed');

  if (!bannerClosed) {
    $banner.css('display', 'flex');
  }

  $close.on('click', () => {
    $banner.css('display', 'none');
    Cookies.set('banner_closed', 'true', { expires: 3 });
    $(window).trigger('bannerClosed');
  });
}
